// React
import { FunctionComponent, useRef, useEffect, useState } from "react"

// UI components
import { Table } from "react-bootstrap"
import VehicleIncidentsTableHeader from "./VehicleIncidentsTableHeader"
import VehicleIncidentsTableBody from "./VehicleIncidentsTableBody/VehicleIncidentsTableBody"
import LazyLoading from "src/components/common/LazyLoading/LazyLoading"
import VehicleIncidentsNoResults from "../VehicleIncidentsNoResults/VehicleIncidentsNoResults"

// Interfaces
import { I_SafetyEvent } from "../../interfaces"

// Shared service
import VIS from "../../VehicleIncidentsService"

// Styles
import "./VehicleIncidentsTable.css"
interface Props {
  events: I_SafetyEvent[]
  loader: number
}

/**
 * Main table component for displaying vehicle incidents.
 * Handles scroll-triggered lazy loading and ties into the VIS service for shared behavior.
 */
const VehicleIncidentsTable: FunctionComponent<Props> = (props) => {

  const { events, loader } = props

  const [lazyLoading, setLazyLoading] = useState<boolean>(false)

  // Scroll reference used by VIS for infinite scroll
  const scrollRef = useRef<HTMLDivElement>(null)
  const { handleScroll } = VIS

  useEffect(() => {
    const scrollElement = scrollRef.current

    // Expose scrollRef and state setter to VIS for global access
    VIS.scrollRef = scrollRef

    Object.assign(VIS, { setLazyLoading })

    VIS.assertVehicleIncidentsTableSettersInitialized()

    const scrollHandler = handleScroll(scrollRef)

    if (scrollElement) {
      scrollElement.addEventListener("scroll", scrollHandler)

      return () => {
        scrollElement.removeEventListener("scroll", scrollHandler)
      }
    }
  }, [handleScroll])

  return (
    <div
      ref={scrollRef}
      className="VehicleIncidentsTable"
      id="vehicle-incidents-table"
    >
      <Table bordered hover id="b1e7c952b143e39529e61519308145">
        <VehicleIncidentsTableHeader />
        <VehicleIncidentsTableBody events={events} loader={loader} />
      </Table>

      {loader < 0 && events.length === 0 && <VehicleIncidentsNoResults />}

      {lazyLoading && <LazyLoading />}
    </div>
  )
}

export default VehicleIncidentsTable